import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_MOTIVATION_LAYER_TOP_8 = defineFcm('psf_share_motivation_layer_top_8')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		deprecated: 'FCM no longer in use — safe to delete after 2026-10-14',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Motivation layer commitment-nudge callout (Top-8 relaunch, CHANGE-100433): kill-switch + experiment binding for the callout above the share channels on the promote_or_share share slide-up. Re-tests the round-1 en-US callout (CHANGE-94929) across all Top-8 countries rather than assuming that result transfers. Country-scoped, not locale-scoped: set one row per Top-8 country (US, GB, AU, CA, DE, FR, IT, JP) and no global or locale rows — a country without a row resolves as disabled and is never enrolled. Do not enable a non-English country before its translation of corgi.psf.promote_or_share.share_slide_up.commitment_nudge is live, or its users see the English fallback.',
		template: {
			enabled: false,
			experimentName: 'psf_share_motivation_layer_top_8',
		},
	});
